<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5" v-if="form != null">
          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.sponsor_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Tag Line</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="tagline"
                  class="w-full"
                  v-model="form.sponsor_tagline"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('tagline')"
                  >{{ errors.first("tagline") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Booth ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="booth_id"
                  class="w-full"
                  v-model="form.booth_id"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('booth_id')"
                  >{{ errors.first("booth_id") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select class="selectExample" v-model="form.sponsor_filter">
                  <vs-select-item
                    :key="index"
                    :value="item.filter_id"
                    :text="item.filter_name"
                    v-for="(item, index) in filterList"
                  />
                </vs-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('filter')"
                  >{{ errors.first("filter") }}</span
                >
              </div>
            </div>
          </section>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update</vs-button
              >
            </div>
          </div>
        </vs-card>

        <vs-card  class="px-5 py-5">
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Logo</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                 <img :src="form.sponsor_logo" style="width:120px;" class="mb-5" />
                 <vs-input
                  type="file"
                  ref="sponsor_logo"
                  name="sponsor_logo"
                  class="w-full"
                  v-model="form.sponsor_logo"
                  @change="setLogo"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('sponsor_logo')"
                  >{{ errors.first("sponsor_logo") }}</span
                >
              </div>
            </div>


               <div class="vx-row pt-5">
                  <div class="vx-col sm:w-2/3 w-full ml-auto">
                  <vs-button
                    class="mr-3 mb-2"
                    @click.prevent="doUploadFile"
                    >Upload</vs-button >
                </div>
              </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    valid: true,
    file:{
      sponsor_logo:null
    },
    form: {
      sponsor_logo:''
    },
    filterList: [],
  }),
  created() {
    setTimeout(() => {

      this.suffixParams = "?s=" + this.$route.query.s + "&e=" + this.$route.query.e

      Service.Sponsor.get(this.id, this.$route.query.e).then((res) => {
        this.form = res.data.sponsor;
        this.loadFilter();
      });
    }, 1000);
  },
  methods: {
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "sponsor",
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then((res) => {
        this.filterList = res.data.rows;
      });
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {

        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    doUploadFile(){
      var formData = new FormData();
      formData.append('e', this.$route.query.e);

      if(this.file.sponsor_logo!=null){
          formData.append('sponsor_logo', this.file.sponsor_logo);
      }
      
      Service.Sponsor.upload(this.id, formData).then(res=>{
        if(res.success){
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          //this.$router.push("/conferences/sponsors"+this.suffixParams);
        }
      })
    },
    setLogo(e){
      this.file.sponsor_logo = e.target.files[0];
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form,
      };
      console.log(data);
      this.$vs.loading();
      Service.Sponsor.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          //this.$router.push("/conferences/sponsors?e=" + this.$route.query.e);
        }
        this.$vs.loading.close();
      });
    },
  },
};
</script>